import * as React from 'react';
import '../../styles/components/tooltip.scss';
import IShopifyImage from '../../interface/ShopifyImage';

interface ResponsiveImageProps {
    image: IShopifyImage
    maxWidth: number
    maxHeight: number
    counter: number
    className?: string
}
const ResponsiveImage = (props: ResponsiveImageProps) => {
    const { image, counter, className, maxWidth, maxHeight } = props;
    return (
        <div id={`ImageWrapper-${ image.id }-${ counter }`} data-image-id={ image.id } className="responsive-image__wrapper" >
            <img
                className={'lazyload ' + className}
                src={ image.src }
                data-src={ image.src.replace('_300x', '_{width}x')}
                data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024]"
                data-aspectratio={ image.aspect_ratio }
                data-sizes="auto"
                alt={ image.alt }
            />
        </div>
    );
};

export default ResponsiveImage;
